import React from "react";
import ShoppingCart from "../../components/User/ShoppingCart";

export default function UserCartPage() {
  return <ShoppingCart />;
}